import type { SupportedRepubName } from './types';

export type BettingSplitsConfig = {
  comparisonBetsLabel: (marketDisplayName: string) => string;
  comparisonMoneyLabel: (marketDisplayName: string) => string;
  defaultEventDisplayName: string;
};

/**
 * Betting splits configurations for each republic
 */
export const BETTING_SPLITS_CONFIGS = {
  GZ: {
    comparisonBetsLabel: () => '% di scommesse 1X2',
    comparisonMoneyLabel: () => '% di distribuzione monetaria 1X2',
    defaultEventDisplayName: 'Serie A',
  },
  OC: {
    comparisonBetsLabel: marketDisplayName => `% of ${marketDisplayName} Bets`,
    comparisonMoneyLabel: marketDisplayName => `% of ${marketDisplayName} Money`,
    defaultEventDisplayName: 'EPL',
  },
  US: {
    comparisonBetsLabel: marketDisplayName => `% of ${marketDisplayName} Bets`,
    comparisonMoneyLabel: marketDisplayName => `% of ${marketDisplayName} Money`,
    defaultEventDisplayName: 'All',
  },
  WS: {
    comparisonBetsLabel: marketDisplayName => `% of ${marketDisplayName} Bets`,
    comparisonMoneyLabel: marketDisplayName => `% of ${marketDisplayName} Money`,
    defaultEventDisplayName: 'All',
  },
} satisfies Record<SupportedRepubName, BettingSplitsConfig>;
